import store from 'store';
import {
  LANDING_GET_STATIC_CONTENT,
  GET_FILTERS,
  PARTNERS_NO_CONTRACT
} from 'store/actions/landing';
import { GET_PARTNER_DATA } from 'store/actions/ui';

const Layout = () => import(/* webpackChunkName: "pages/main" */ 'layout');
const Error = () => import(/* webpackChunkName: "pages/views/error" */ 'views/Error');
const Landing = () => import(/* webpackChunkName: "pages/views/landing" */ 'views/Landing');
const Detail = () =>
  import(/* webpackChunkName: "pages/views/Landing/detail" */ 'views/Landing/Detail');
const Legal = () => import(/* webpackChunkName: "pages/views/Legal" */ 'views/Legal');

// Redirect to the error page
const redirectToErrorPage = next =>
  next({
    name: '404'
  });

export default [
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: ':popupstore([a-z]+)/:partnerId(\\d+)/:groupId([0-9A-Z]+)',

        component: {
          render(c) {
            if (this.$route.query.quoteId) {
              return c(Detail);
            }
            return c(Landing);
          }
        },
        meta: { titleKey: 'home' },
        name: 'landing',
        beforeEnter(to, from, next) {
          Promise.all([
            store.dispatch(`ui/${GET_PARTNER_DATA}`, {
              id: to.params.partnerId
            })
          ])
            .then(() => {
              const partners = JSON.parse(process.env.PARTNERS_NO_CONTRACT);
              const partnersNoContract = {
                id: to.params.partnerId,
                ...partners[to.params.partnerId]
              };
              store.commit(`landing/${PARTNERS_NO_CONTRACT}`, partnersNoContract);
              Promise.all([
                store.dispatch(`landing/${LANDING_GET_STATIC_CONTENT}`, {
                  partnerId: to.params.partnerId
                }),
                store.dispatch(`landing/${GET_FILTERS}`)
              ])
                .then(() => {
                  next();
                })
                .catch(() => redirectToErrorPage(next));
            })
            .catch(() => redirectToErrorPage(next));
        }
      },
      {
        path: 'legal/:type',
        component: Legal,
        name: 'legal',
        props: { whithoutLinksFooter: true },
        meta: { titleKey: 'legal' }
      },
      {
        path: 'error',
        name: 'error',
        component: Error,
        props: { type: '500_es-ES' },
        meta: { titleKey: 'error' }
      },
      {
        path: '*',
        name: '404',
        component: Error,
        props: { type: '404_es-ES' },
        meta: { titleKey: 'notFound' }
      }
    ]
  }
];
